import { render } from "./WorkflowIsLoading.vue?vue&type=template&id=5de402b6"
import script from "./WorkflowIsLoading.vue?vue&type=script&lang=js"
export * from "./WorkflowIsLoading.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__